/* Maximum character limit for the in-chat feedback survey textarea */
export const SURVEY_FEEDBACK_MAX_LENGTH = 8000;
